module.exports = __webpack_public_path__ + "static/Illu_Work-c98f67814b4c315d2ff6e844b2ffc5b3.svg";